import Footer from "./footer";

const Carousel = {
    init () {
        document.querySelectorAll('.carousel-wrapper').forEach(this.initCarousel);
    },

    initCarousel (wrapper) {
        const carousel = wrapper.querySelector('.carousel');
        const items = carousel.querySelectorAll('.carousel-item');
        const dotsContainer = wrapper.querySelector('.carousel-dots');
        const prevBtn = wrapper.querySelector('.carousel-btn.prev');
        const nextBtn = wrapper.querySelector('.carousel-btn.next');
        const itemWidth = items[0].offsetWidth;

        const visibleWidth = carousel.offsetWidth;

        const itemsPerPage = Math.floor(visibleWidth / itemWidth);
        let items_length = items.length;
        console.log(itemsPerPage);

        if (itemsPerPage === 2) {
            items_length = items_length - 1;
        }

        if (itemsPerPage === 3) {
            items_length = items_length - 2;
        }

        if (itemsPerPage === 4) {
            items_length = items_length - 3;
        }

        // Create dots per item
        for (let i = 0; i < items_length; i++) {
            const dot = document.createElement('span');
            dot.className = 'carousel-dot';
            if (i === 0) dot.classList.add('active');
            dot.addEventListener('click', () => {
                carousel.scrollTo({ left: i * itemWidth, behavior: 'smooth' });
            });
            dotsContainer.appendChild(dot);
        }

        const updateDots = () => {
            const scrollLeft = carousel.scrollLeft;
            const currentIndex = Math.round(scrollLeft / itemWidth);
            wrapper.querySelectorAll('.carousel-dot').forEach((dot, i) => {
                dot.classList.toggle('active', i === currentIndex);
            });
        };

        if (nextBtn) {
            nextBtn.onclick = () => {
                carousel.scrollBy({ left: itemWidth, behavior: 'smooth' });
            };
        }

        if (prevBtn) {
            prevBtn.onclick = () => {
                carousel.scrollBy({ left: -itemWidth, behavior: 'smooth' });
            };
        }


        carousel.addEventListener('scroll', () => {
            clearTimeout(carousel._scrollTimer);
            carousel._scrollTimer = setTimeout(updateDots, 100);
        });
    }
}

export default Carousel;